module.exports = __webpack_public_path__ + "img/h7.69a538a3.png";